import './Layout.scss';
import Layout from "./Layout";

export default Layout;